function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { formatDistanceToNowStrict, subMinutes } from "date-fns";
import Calendar from "react-ultimate-calendar";
var HOUR = 60; // 60 minutes
var DAY = HOUR * 24;
var RANGES = [
    5,
    30,
    HOUR,
    12 * HOUR,
    DAY,
    2 * DAY,
    7 * DAY
];
var getMinutesRange = function(date) {
    return function(config, minutes) {
        var differenceInMinutes = subMinutes(date, minutes);
        var distance = formatDistanceToNowStrict(differenceInMinutes);
        return _object_spread_props(_object_spread({}, config), _define_property({}, "Last ".concat(distance), [
            differenceInMinutes,
            date
        ]));
    };
};
var getRanges = function(date) {
    return RANGES.reduce(getMinutesRange(date), {});
};
export var DatePicker = function(param) {
    var date = param.date, name = param.name, onChange = param.onChange, showRanges = param.showRanges;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "date-range-".concat(name),
        children: /*#__PURE__*/ _jsx(Calendar, {
            locale: "en-GB",
            multi: true,
            onChange: function(_, start, end) {
                if (start && end) {
                    onChange === null || onChange === void 0 ? void 0 : onChange([
                        start,
                        end
                    ]);
                }
            },
            rangePresets: showRanges ? getRanges(date) : undefined,
            timeSelector: true
        })
    });
};

//# sourceMappingURL=DatePicker.js.map